import { motion } from 'framer-motion';
import { Coffee } from 'lucide-react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

const MENU_IMAGE_URL = "https://customer-assets.emergentagent.com/job_sip-schedule-admin/artifacts/sg8uswjl_MENU-Final.jpg";

export const MenuPage = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="menu-page">
      <Navbar />
      
      {/* Header */}
      <section className="bg-gradient-to-r from-sip-blue via-sip-pink to-sip-yellow py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <Coffee className="w-12 h-12 mx-auto mb-3 text-white" />
            <h1 className="font-script text-4xl md:text-5xl text-white mb-2">
              Our Menu
            </h1>
            <p className="text-lg text-white/90 max-w-2xl mx-auto">
              Handcrafted drinks that'll make your taste buds dance!
            </p>
          </motion.div>
        </div>
      </section>

      {/* Menu Image */}
      <section className="py-8 md:py-12">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
            className="relative"
          >
            <img
              src={MENU_IMAGE_URL}
              alt="Sip Fantasia Menu - Build Your Own drinks, Sip Worthy Picks, and All The Yums flavors"
              className="w-full h-auto rounded-2xl shadow-2xl"
              data-testid="menu-image"
            />
          </motion.div>
          
          {/* Call to action */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
            className="text-center mt-8"
          >
            <p className="text-gray-600 text-lg">
              Can't decide? Try one of our <span className="font-semibold text-sip-navy">Sip Worthy Picks</span> or build your own masterpiece!
            </p>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default MenuPage;
